export enum CrmTypes {
  LIST_WHATSAPP_MESSAGES = 'LIST_WHATSAPP_MESSAGES',
  SET_LOADING_WHATSAPP_MESSAGES = 'SET_LOADING_WHATSAPP_MESSAGES',
  LIST_SMS_MESSAGES = 'LIST_SMS_MESSAGES',
  SET_LOADING_SMS_MESSAGES = 'SET_LOADING_SMS_MESSAGES',
  SET_SMS_BALANCE = 'SET_SMS_BALANCE',
  SET_LOADING_SMS_BALANCE = 'SET_LOADING_SMS_BALANCE',
  LOGOUT = 'LOGOUT',
}

